/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const SheetTreatments = core.serialization.enum_(["CLIPPED_FROM_SHEET", "ENUM_REFERENCE"]);
